import { Component, Input, OnChanges } from '@angular/core'
import { WebsitePreviewPackage } from './ibranson-preview.iface'

@Component({
  selector: 'app-ib-packages',
  templateUrl: './ib-packages.component.html',
  standalone: false,
})
export class IbPackagesComponent implements OnChanges {
  @Input() packages: WebsitePreviewPackage[] | null = null

  list: WebsitePreviewPackage[] = []

  ngOnChanges() {
    this.list = this.packages || []
  }
}
